import { CustomParamScenario, CustomField } from './model';
import { fetchApi, ApiResponse } from './common';

// 自定义字段相关请求接口
export interface CreateCustomFieldRequest {
  name: string;
  hint: string;
  scenario: CustomParamScenario;
  order: number;
  extra?: Record<string, any>;
  is_enabled: boolean;
  visible_to_customer: boolean;
  is_multiline: boolean;
}

export interface UpdateCustomFieldRequest {
  name?: string;
  hint?: string;
  order?: number;
  extra?: Record<string, any>;
  visible_to_customer?: boolean;
  is_multiline?: boolean;
}

// 自定义字段API请求函数
export const customFieldApi = {
  // 获取自定义字段列表
  listCustomFields: async (scenario?: CustomParamScenario): Promise<ApiResponse<CustomField[]>> => {
    const params = new URLSearchParams();
    if (scenario) {
      params.append('scenario', scenario);
    }
    const queryString = params.toString();
    const url = queryString ? `/api/doctor_view/custom_fields?${queryString}` : '/api/doctor_view/custom_fields';
    return fetchApi<CustomField[]>(url, 'GET');
  },

  // 创建自定义字段
  createCustomField: async (data: CreateCustomFieldRequest): Promise<ApiResponse<CustomField>> => {
    return fetchApi<CustomField>('/api/doctor_view/custom_fields', 'POST', data);
  },

  // 更新自定义字段
  updateCustomField: async (id: string, data: UpdateCustomFieldRequest): Promise<ApiResponse<CustomField>> => {
    return fetchApi<CustomField>(`/api/doctor_view/custom_fields/${id}`, 'PUT', data);
  },

  // 设置自定义字段启用状态
  setCustomFieldEnabled: async (id: string, isEnabled: boolean): Promise<ApiResponse<CustomField>> => {
    return fetchApi<CustomField>(`/api/doctor_view/custom_fields/${id}/set_enabled`, 'PUT', {
      is_enabled: isEnabled
    });
  }
};